import type { ProductName } from '@atlassian/jira-shared-types/src/product-name.tsx';
import { useApplicationPermissions } from '../application-permissions/index.tsx';
import { getProductName } from './utils.tsx';

export const useProductName = (): ProductName => {
	const appPermissions = useApplicationPermissions();
	return getProductName(appPermissions);
};
